import { render, staticRenderFns } from "./product_categories.vue?vue&type=template&id=50d5aa65&scoped=true&"
import script from "./product_categories.vue?vue&type=script&lang=js&"
export * from "./product_categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d5aa65",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50d5aa65')) {
      api.createRecord('50d5aa65', component.options)
    } else {
      api.reload('50d5aa65', component.options)
    }
    module.hot.accept("./product_categories.vue?vue&type=template&id=50d5aa65&scoped=true&", function () {
      api.rerender('50d5aa65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/product/tabs/product_categories.vue"
export default component.exports